import { language } from '@app/models/language';
import {gql} from 'apollo-angular';

export const languagesResult = 'languages';
export const languagesQuery = gql`
    query Languages {
        languages {
            ...language
        }
    }
    ${language}
`;
